"use client";

import { useEffect, useState } from "react";
// import Link from 'next/link'
import isBrowser from "../helpers/is_browser";
import { pageDataAtom, wsAllowedAtom } from "../state";
import { useAtom } from "jotai";
import headers from "@/app/helpers/default_headers.ts";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import useGlobalClickHandler from "@/app/components/global_click_handler";
import DefaultLayout from "@/app/default_layout";

// eslint-disable-next-line
import { redirect } from "next/dist/server/api-utils";
// import iosLaunchLogo from "@/app/images/ios_launch.webp"
// import Image from "next/image"

const emailRegex = new RegExp(
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i,
);

let fpPromise;
if (isBrowser()) {
  fpPromise = FingerprintJS.load();
}

export default function LoginPage() {
  const [pageData] = useAtom(pageDataAtom);
  // eslint-disable-next-line
  const [valid, setValid] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  // eslint-disable-next-line
  const [wsAllowed, setWsAllowed] = useAtom(wsAllowedAtom);
  const [passwordAllowed, setPasswordAllowed] = useState(false);
  const [validEmail, setValidEmail] = useState(false);

  setWsAllowed(false);
  useGlobalClickHandler(fpPromise);

  function emailChg(ev) {
    let v;

    try {
      v = ev.currentTarget.value.trim();
    } catch (e) {
      console.log("Ignoring error: ", e);
      return;
    }

    if (v !== "") {
      setEmail(() => v);

      const _validEmail = email.match(emailRegex) !== null;
      setValidEmail(() => _validEmail);

      if (_validEmail && !v.endsWith("@evansenergyonline.com")) {
        setValidEmail(() => true);
        setPasswordAllowed(() => true);
      } else if (_validEmail && v.endsWith("@evansenergyonline.com")) {
        setValidEmail(() => true);
        setPasswordAllowed(() => false);
      } else if (password != "") {
        setValid(() => true);
      }
    } else {
      setValid(() => false);
    }
  }

  function passwordChg(ev) {
    const v = ev.currentTarget.value.trim();
    // console.log(valid)

    if (v !== "") {
      setPassword(v);
      if (email != "") {
        setValid(() => true);
      }
    } else {
      setValid(() => false);
    }
  }

  // eslint-disable-next-line
  function trackUsernameInput(ev) {
    if (pageData && pageData.highlightEnabled) {
      const username = ev.currentTarget.value.trim();
      H.track("USERNAME_INPUT", {
        username,
        datetime: new Date(),
      });
    }
  }

  async function handleCommonLoginSuccess(json, redirect, _email) {
    if (!json.res) {
      setError("Invalid username or password.");
      return;
    }
    const search = new URLSearchParams(location.search);
    let _redirect;
    if (search.has("redirect")) {
      _redirect = search.get("redirect");
    }

    // localStorage.clear();
    // localStorage.setItem(
    //   "field_well_selector",
    //   JSON.stringify({ selectedFieldId: -1, selectedWellId: -1 }),
    // );

    /*
    try {
      const regs = await navigator.serviceWorker.getRegistrations()
      for (const registration of regs) {
        registration.unregister()
      }
    } catch (err) {
      console.error("Error unregistering service workers", err)
    }
 */

    const cache = await caches.open("fields-api-cache");
    const keys = await cache.keys();
    for (let x = 0; x < keys.length; x++) {
      const key = keys[x];
      await cache.delete(key);
    }

    if (Array.isArray(json.well_ids)) {
      localStorage.setItem("well_ids", JSON.stringify(json.well_ids));
    }

    if (Array.isArray(json.field_ids)) {
      localStorage.setItem("field_ids", JSON.stringify(json.field_ids));
    }

    localStorage.setItem("email", _email);

    const savedRedirect = localStorage.getItem("redirect");

    if (savedRedirect !== null) {
      localStorage.removeItem("redirect");
      location.href = savedRedirect;
      return;
    }

    if (redirect || _redirect) {
      return (location.href = redirect);
    }
    if (
      json.res &&
      Array.isArray(json.capabilities) &&
      json.capabilities.includes("Legal")
    ) {
      location.href = "/legal";
    } else if (json.res && Array.isArray(json.capabilities)) {
      location.href = "/fields";
    } else if (json.res) {
      location.href = "/projects";
    } else {
      setError("Invalid username or password.");
    }
  }

  function signIn(redirect) {
    const emailEl = document.getElementById("email");
    const passwordEl = document.getElementById("password");
    const _email = email === "" ? emailEl.value : email;
    const _password = password === "" ? passwordEl.value : password;

    // let _res

    fetch(`/accounts/sign_in`, {
      method: "POST",
      headers,
      body: JSON.stringify({ email: _email, password: _password }),
    }).then((res) => {
      if (res.status === 200) {
        // _res = res

        // if (Capacitor.getPlatform() === "ios") {
        //   SavePassword.promptDialog({
        //     username: _email,
        //     password: _password,
        //   });
        // }

        res.json().then((json) => {
          handleCommonLoginSuccess(json, redirect, _email);
        });
      }
    });
  }

  useEffect(() => {
    const tmp = () => {
      const activeEl = document.activeElement;
      if (activeEl.getAttribute("id") === "email") {
        emailChg({ currentTarget: activeEl });
      }
    };
    const tmpInt = setInterval(tmp, 200);
    return () => clearInterval(tmpInt);
  });
  useEffect(() => {
    if (isBrowser() && pageData !== null && pageData.loggedIn) {
      if (Array.isArray(pageData.well_ids)) {
        localStorage.setItem("well_ids", JSON.stringify(pageData.well_ids));
      }

      if (Array.isArray(pageData.field_ids)) {
        localStorage.setItem("field_ids", JSON.stringify(pageData.field_ids));
      }

      if (pageData.capabilities) {
        location.href = "/fields";
      } else location.href = "/projects";
    }
  }, [pageData]);

  return (
    <DefaultLayout>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Login to your account
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          {error === "" ? null : (
            <div className="mb-10 text-red-600">{error}</div>
          )}
          <div className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email address
              </label>
              <div className="mt-2">
                <input
                  onChange={emailChg}
                  onBlurCapture={emailChg}
                  id="email"
                  name="email"
                  type="email"
                  required
                  // onBlur={trackUsernameInput}
                  onKeyUp={(ev) => {
                    if (ev.code === "Enter") {
                      signIn(pageData?.redirect);
                    }
                  }}
                  autoComplete="email"
                  className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-950 sm:text-sm sm:leading-6 p-4"
                />
              </div>
            </div>

            {passwordAllowed && validEmail && (
              <div>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Password
                  </label>
                  <div className="text-sm">
                    <a href={"/accounts/password/new"}>Forgot password?</a>
                  </div>
                </div>
                <div className="mt-2">
                  <input
                    onChange={passwordChg}
                    id="password"
                    name="password"
                    type="password"
                    required
                    onKeyUp={(ev) => {
                      if (ev.code === "Enter") {
                        signIn(pageData?.redirect);
                      }
                    }}
                    autoComplete="current-password"
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-950 sm:text-sm sm:leading-6 p-4"
                  />
                </div>
              </div>
            )}

            {passwordAllowed && validEmail && (
              <div>
                <button
                  type="submit"
                  onClick={() => signIn(pageData?.redirect)}
                  onKeyUp={(ev) => {
                    if (ev.code === "Enter") {
                      signIn(pageData?.redirect);
                    }
                  }}
                  className="flex w-full justify-center rounded-md bg-indigo-950 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-lime-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-950"
                >
                  Sign In
                </button>
              </div>
            )}

            {!passwordAllowed && validEmail && (
              <div>
                {/* <form action="/auth/microsoft_graph_auth" accept-charset="UTF-8" method="post"> */}
                <button
                  type="submit"
                  onClick={() => {
                    const state = {};
                    if (pageData?.redirect) {
                      state.redirect = pageData.redirect;
                    }
                    const host = location.host;
                    const proto = location.protocol;
                    const redirect = `${proto}//${host}/auth/microsoft_graph_auth/callback`;
                    location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=557cba08-e92e-4e5e-81e8-46383a60dd9c&redirect_uri=${redirect}&response_type=id_token&scope=openid%20profile%20email%20offline_access%20user.read%20mailboxsettings.read%20calendars.readwrite&state=${JSON.stringify(
                      state,
                    )}&nonce=${crypto.randomUUID()}&login_hint=${email}&response_mode=form_post`;
                  }}
                  className="flex w-full justify-center rounded-md bg-indigo-950 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-lime-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-950"
                >
                  Continue
                </button>
                {/* </form> */}
              </div>
            )}
          </div>
        </div>
        {/* {Capacitor.isNativePlatform() ? null : (

          <div className="mt-4 p-4 sm:mx-auto sm:w-full sm:max-w-sm">
            <a href="https://apps.apple.com/us/app/evans-energy-ii-portal/id6740833113" target="_blank">
              <Image alt="iOS App Launch" src={iosLaunchLogo} />
            </a>
          </div>
        )} */}
      </div>
    </DefaultLayout>
  );
}
